module.exports = __webpack_public_path__ + "img/ic_bad_check.08ce3b3e.png";